import { styled } from 'styled-components';
import mediaQuery, { Breakpoint, breakpoints } from '@/styles/mediaQuery';

export const PublicFormTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.sizes.lg};

  ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  }
`;

export const PublicFormSubtitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  color: ${({ theme }) => theme.system.neutral.text.muted};
`;

export const PublicFormInputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
`;

export const PublicFormButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  width: 100%;
  margin-top: ${({ theme }) => theme.spaces.padding.md};
`;
